<template>
  <div class="teacher-video-wrapper">
    <template v-if="loading">
      <van-skeleton avatar class="acatar-skeleton" />
      <van-skeleton title :row="3" />
    </template>
    <template v-else>
      <template v-if="isVideo">
        <video-layout
          :nav-title="`${item.category}详情`"
          :item="item"
          :back="back"
        >
          <backdrop-video :item="item" />
          <basis-locked
            v-if="item.locked"
            support-vip
            :item="item"
            :locked-data="item"
            @clickHandler="clickHandler"
          />
        </video-layout>
      </template>
      <template v-else>
        <artical-layout
          :nav-title="`${item.category}详情`"
          :item="item"
          :back="back"
        >
          <div :class="['artical', {'is-locked': item.locked}]" v-html="item.caption" />
          <basis-locked
            v-if="item.locked"
            support-vip
            :item="item"
            :locked-data="item"
            @clickHandler="clickHandler"
          />
        </artical-layout>
      </template>
    </template>
  </div>
</template>

<script>
import { BasisLocked } from '@/components/basis'
import BackdropVideo from './components/BackdropVideo'
import VideoLayout from './components/VideoLayout'
import ArticalLayout from './components/ArticalLayout'
import { mapActions } from 'vuex'
import { Video } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'TeacherVideo',
  components: { BasisLocked, BackdropVideo, VideoLayout, ArticalLayout },
  mixins: [mixinWxShare],
  data: () => ({
    loading: true,
    isVideo: true,
    payType: '',
    item: {
      category: undefined
    }
  }),
  async mounted () {
    try {
      const { id } = this.$route.params
      const { video } = await Video.detail({ id })
      this.behaviorByCategory(video)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapActions(['updateVip']),
    behaviorByCategory (item) {
      switch (true) {
        case item.category.includes('视频'):
          this.isVideo = true
          break
        case item.category.includes('文章'):
          this.isVideo = false
          break
        case item.category.includes('转载'):
          this.isVideo = true
          !item.locked && window.location.replace(item.video)
          break
      }
      this.item = item
      this.loading = false
    },
    back () {
      const { teacherId } = this.$route.params
      this.$router.push({
        name: 'teacher-videos',
        params: {
          teacherId
        }
      })
    },
    clickHandler (type) {
      this.payType = type
      switch (type) {
        case 'credits':
          // 暂无积分解锁教师视频功能
          break
        case 'vip':
          // 前往 VIP 充值 Locked 组件中包含该功能
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-video-wrapper {
  .acatar-skeleton {
    ::v-deep {
      .van-skeleton__avatar {
        @include wh(100% !important, 180px !important);
        border-radius: 0;
        margin-bottom: 20px;
      }
    }
  }
  .artical {
    &.is-locked {
      filter: blur(2px);
    }
  }
}
</style>
